import React, {FC, useCallback} from 'react';
import styled from 'styled-components';

import {CalendarDate} from '../../../helpers/date';
import {StepFrame} from '../../common/step/frame/stepFrame';
import {Step, StepProps} from '../../common/step/step';
import {AvailabilityDatePicker} from '../../datePicker/availabilityDatePicker';
import {buildBookTitle} from '../bookHelpers';
import {BookStepTypesEnum} from '../bookStep';

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  padding: 8px 0px;
`;

/*
 * Component.
 */

export const BookStepChooseDate: FC<StepProps> = (props) => {
  const {onNext, metadata, availability, schedulingLink} = props;

  const onSelectDate = useCallback(
    (selectedDate: CalendarDate) => {
      if (!onNext) {
        return;
      }

      onNext((data) => ({
        ...data,
        selectedDate,
      }));
    },
    [onNext],
  );

  if (!availability) {
    return null;
  }

  return (
    <StepFrame title={buildBookTitle(schedulingLink)} metadata={metadata}>
      <StyledContentDiv>
        <AvailabilityDatePicker
          schedulingLink={props.schedulingLink}
          selectedDate={props.selectedDate}
          onSelectDate={onSelectDate}
          availability={availability}
        />
      </StyledContentDiv>
    </StepFrame>
  );
};

/*
 * Step.
 */

export const bookStepChooseDate: Step<BookStepTypesEnum> = {
  type: BookStepTypesEnum.CHOOSE_DATE,
  renderStep: (props) => React.createElement(BookStepChooseDate, props),
};
